import { PDFDocument, PDFFont, PDFPage, rgb, StandardFonts } from 'pdf-lib';
import { Injectable } from '@angular/core';
import { fileToArrayBuffer, uint8ArrayToFile } from '../helpers/file-helpers';
import { PDF_MIME_TYPE } from '../constants/constants';
import { FormattedDatePipe } from '../pipes/formatted-date/formatted-date.pipe';
import { IFileUploadObject } from '../components/file-uploader/file-upload-object.interface';
import { ReceiveAttachmentSignatureDoc } from 'src/app/inventory/dialogs/receive-attachments-dialog/receive-attachment-signature-doc';
import { ISignedFileObject } from '../components/file-uploader/signed-file-object.interface';

@Injectable()
export class PdfSignatureService {
  constructor(private datePipe: FormattedDatePipe) {}

  async sign(
    pdfFiles: IFileUploadObject[],
    signature,
    name: string,
    pharmacyName: string,
    performedDate: Date,
    recordedDate: Date = new Date()
  ): Promise<void> {
    await Promise.all(
      pdfFiles.map(async (pdfFile: IFileUploadObject) => {
        await this.signSingleFile(pdfFile, signature, name, pharmacyName, performedDate, recordedDate);
      })
    );
  }
  /**
   * @description
   * Signature embedded in file object
   */
  async sign2(
    pdfFiles: ISignedFileObject[],
    name: string,
    pharmacyName: string,
    performedDate: Date,
    recordedDate: Date = new Date()
  ): Promise<void> {
    await Promise.all(
      pdfFiles.map(async (pdfFile: ISignedFileObject) => {
        await this.signSingleFile(pdfFile, pdfFile.signature, name, pharmacyName, performedDate, recordedDate);
      })
    );
  }


  private async signSingleFile(pdfFile: IFileUploadObject,
    signature,
    name: string,
    pharmacyName: string,
    performedDate: Date,
    recordedDate: Date = new Date()): Promise<void>  {
      if (
        pdfFile.selectedFile &&
        pdfFile.selectedFile.type === PDF_MIME_TYPE
      ) {
        try {
          let signatureDoc = await new ReceiveAttachmentSignatureDoc(this.datePipe)
            .get(pharmacyName, signature, name, performedDate, recordedDate, pdfFile.type, pdfFile.otherType, pdfFile.name);

          let pdfBuffer = await fileToArrayBuffer(pdfFile.selectedFile);
          let userDoc = await PDFDocument.load(pdfBuffer);

          //for already signed docs, remove the old signature page
          if (pdfFile.isSigned) {
            const pageCount = userDoc.getPageCount();
            userDoc.removePage(pageCount - 1);
          };

          let signaturePages = await userDoc.copyPages(signatureDoc, signatureDoc.getPageIndices());

          signaturePages.forEach(page => {
            userDoc.addPage(page);
          })

          // Save the updated PDF
          let pdfBytes = await userDoc.save();
          pdfFile.selectedFile = uint8ArrayToFile(
            pdfBytes,
            'Signed ' + pdfFile.name,
            PDF_MIME_TYPE
          );
          
          pdfFile.isSigned = true;

          signatureDoc = null;
          userDoc = null;
          signaturePages = null;
          pdfBytes = null;
        } catch (error) {
          console.error(`Error processing file ${pdfFile.name}:`, error);
        }
      }
    }
}
